import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "27",
  fill: "none",
  viewBox: "0 0 30 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "4",
      d: "M4 2h22a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-4.86a6 6 0 0 0-4.992 2.672L15 23.395l-1.148-1.723A6 6 0 0 0 8.859 19H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"
    }, null, -1)
  ]))]))
}
export default { render: render }